<template>
  <div class="page-container">
    <div class="shadow-sm custom-nav-header">
      <h4>Custom Navigation</h4>
    </div>
    <div class="content-wrapper">
      <item-list class="item-list" />
      <item-content class="item-content" />
    </div>
    <div class="page-footer">
      <b-button
        variant="primary"
        class="submit-btn"
        @click="onSubmitLeftNav"
      >
        <b-spinner
          v-if="isLoading"
          variant="light"
          small
        />
        <font-awesome-icon
          v-else
          :icon="['far', 'save']"
        />
        Submit
      </b-button>
    </div>
  </div>
</template>

<script>
import { isEqual } from 'lodash';
import ItemContent from './components/ItemContent.vue';
import ItemList from './components/ItemList.vue';
import {createNamespacedHelpers} from 'vuex';

const {
  mapActions: leftNavCustomizationMapActions,
  mapState: leftNavCustomizationMapState,
} = createNamespacedHelpers('leftNavCustomization');
export default {
  name: 'LeftNavCustomizationPage',
  components: {
    ItemContent,
    ItemList,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    ...leftNavCustomizationMapState({
      leftNavData: state=>state.leftNavData,
      initialLeftNavData: state => state.initialLeftNavData,
    }),
  },
  methods: {
    ...leftNavCustomizationMapActions([
      'getLeftNavData', 
      'saveLeftNavData', 
      'returnInitialNavData',
      'clearSelectedItem',
    ]),
    async onSubmitLeftNav() {
      this.isLoading = true;
      const result = await this.saveLeftNavData(this.leftNavData);
      if (!result.success) {
        this.$toasted.error(result.body.ErrorMessage, {duration: TOASTER_DURATION});
      } else {
        this.$toasted.success('Left navigation updated successfully', {duration: TOASTER_DURATION});
      }
      this.isLoading = false;
    },
  },
  async beforeMount() {
    await this.getLeftNavData();
  },
  async beforeRouteLeave(from, to, next){
    if(isEqual(this.leftNavData, this.initialLeftNavData)){
      this.clearSelectedItem();
      return next();
    }
    const confirm = await this.$confirm(
      'Redirecting...',
      'Changes are not saved. Are you sure you want to continue?',
    );
    if (confirm) {
      this.returnInitialNavData();
      next();
    }
  },
};

</script>

<style scoped lang="scss">
.toolbar-wrapper {
  display: flex;
  align-items: center;
}

.toolbar-wrapper {
  background-color: #fff;
  padding: 10px 20px;
  border-bottom: 1px solid #ddd;
  justify-content: space-between;
}

.item-list {
  width: 300px;
  overflow-y: auto;
  padding: 8px;
  border: 1px solid #eee;
}

.item-content {
  flex: 1;
  background: #fff;
  padding: 20px;
  overflow-y: auto;
}

.page-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.content-wrapper {
  display: flex;
  flex: 1;
  height: 88vh;
  padding: 10px 20px 0;
}

.custom-nav-header {
  padding: 12px;
  background-color: white;

  h4 {
    margin: 0;
  }
}

.page-footer {
  padding: 10px 20px 20px;

  .submit-btn {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }
}
</style>